import { c as _c } from "react/compiler-runtime";
import { Controller } from "@website/form/hook/form.hooks";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { TextField } from "@website/ui/text-field";
import { useTelesales } from "@website/widget/telesales/telesales-form/hooks";
import { TelesalesFormPropertiesType, TelesalesFromDataType } from "@website/widget/telesales/telesales-form/types";
import { Control } from "react-hook-form";
export const TelesalesForm = t0 => {
  const $ = _c(29);
  const {
    onClose,
    isSubmitBefore,
    requestData,
    storageKey,
    reasons,
    description,
    onSuccess,
    onSubmitSuccess
  } = t0;
  let t1;
  if ($[0] !== onClose || $[1] !== onSubmitSuccess || $[2] !== onSuccess || $[3] !== reasons || $[4] !== requestData || $[5] !== storageKey) {
    t1 = {
      onClose,
      requestData,
      storageKey,
      reasons,
      onSuccess,
      onSubmitSuccess
    };
    $[0] = onClose;
    $[1] = onSubmitSuccess;
    $[2] = onSuccess;
    $[3] = reasons;
    $[4] = requestData;
    $[5] = storageKey;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    handleSetEvent,
    isPhoneStep,
    control,
    isPending,
    handleSubmit
  } = useTelesales(t1);
  if (isSubmitBefore) {
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="text-body-2 text-on-surface-high-emphasis">درخواست شما قبلا ثبت شده است و به زودی کارشناسان ما با شما تماس خواهند گرفت.</div>;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== onClose) {
      t3 = <>{t2}<Button children={"\u0628\u0633\u062A\u0646"} className="mt-4" color="secondary" fullWidth={true} onClick={onClose} size="large" variant="outline" /></>;
      $[8] = onClose;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t2;
  if ($[10] !== handleSetEvent || $[11] !== handleSubmit) {
    t2 = handleSubmit(handleSetEvent);
    $[10] = handleSetEvent;
    $[11] = handleSubmit;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== control || $[14] !== isPhoneStep || $[15] !== reasons) {
    t3 = isPhoneStep ? <><div>لطفا شماره موبایل خود را وارد کنید.</div><div className="my-6"><Controller control={control as unknown as Control<TelesalesFromDataType>} name="freeTransferMobileNumber" render={_temp} /></div></> : <><div className="mb-4">لطفا دلایل خود را برای رزرو تلفنی مشخص کنید.</div><div className="flex w-full flex-wrap gap-x-2 gap-y-4">{Object.entries(reasons).map(reason => <div key={reason[0]}><Controller control={control as unknown as Control<TelesalesFromDataType>} name={reason[0]} render={t4 => {
            const {
              field: field_0
            } = t4;
            return <><input className="peer hidden" id={reason[0]} type="checkbox" {...field_0} /><label className="text-button text-on-surface-high-emphasis border-on-surface-disable peer-checked:text-secondary peer-checked:border-secondary inline-flex cursor-pointer overflow-hidden rounded-full border px-3 py-2" htmlFor={reason[0]}>{reason[1]}</label></>;
          }} /></div>)}</div><div className="my-6"><Controller control={control as unknown as Control<TelesalesFromDataType>} name="reason" render={_temp2} /></div></>;
    $[13] = control;
    $[14] = isPhoneStep;
    $[15] = reasons;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== description) {
    t4 = <div>{description}</div>;
    $[17] = description;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <div className="text-body-2 text-on-surface-high-emphasis">{t3}{t4}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = isPhoneStep ? "\u062A\u0627\u06CC\u06CC\u062F \u0648 \u0627\u062F\u0627\u0645\u0647" : "\u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A";
  let t7;
  if ($[22] !== isPending || $[23] !== t6) {
    t7 = <Button children={t6} className="mt-4" color="secondary" fullWidth={true} loading={isPending} size="large" type="submit" variant="contained" />;
    $[22] = isPending;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t2 || $[26] !== t5 || $[27] !== t7) {
    t8 = <form onSubmit={t2}>{t5}{t7}</form>;
    $[25] = t2;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};
function _temp(t0) {
  const {
    field,
    fieldState: t1
  } = t0;
  const {
    error
  } = t1;
  return <TextField StartIcon={<MaterialIcon name="phone_iphone" />} error={Boolean(error)} fullWidth={true} helperText={error?.message} inputMode="text" placeholder={"\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644"} type="tel" {...field} />;
}
function _temp2(t0) {
  const {
    field: field_1
  } = t0;
  return <textarea className="border-on-surface-disable w-full rounded-lg border p-4" placeholder={"\u0633\u0627\u06CC\u0631 \u062F\u0644\u0627\u06CC\u0644 \u062E\u0648\u062F \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F."} rows={4} {...field_1} />;
}